import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default new VueI18n({
  locale: navigator.language,
  messages: {
    pt: {
      currency: {
        style: 'currency',
        currency: 'BRL',
      },
      message: {
        footer1: 'Estes dados serão usados unicamente para fins de processamento seguro de transações de pagamento. Outros detalhes como loja, website ou itens comprados não são compartilhados e permanecem sob sigilo.',
        footer2: 'O seu endereço é usado unicamente para fins de processamento seguro de transações de pagamento e não será usado para correspondência ou qualquer outro fim.',
        nameFieldInfo: 'Por favor, insira o seu nome como está escrito no seu documento de identidade.',
        surnameFieldInfo: 'Por favor, insira o seu último sobrenome como está escrito no seu documento de identidade.',
        taxIdInfo: 'Por favor, forneça um número de documento válido ou a transação será negada. O seu número de documento é usado unicamente para fins de processamento de transações de pagamento.',
        cardHolderInfo: 'Por favor insira o seu nome como está escrito no seu cartão.',
        namePlaceholder: 'Digite seu primeiro nome',
        name: 'Nome',
        surname: 'Sobrenome',
        surnamePlaceholder: 'Digite seu sobrenome',
        confirm: 'Confirmar Dados',
        zipCode: 'CEP',
        address: 'Endereço',
        addressNumber: 'Número',
        city: 'Cidade',
        additionalInfo: 'Complemento',
        state: 'Estado',
        country: 'País',
        cardHolderName: 'Nome do Titular do Cartão',
        taxId: 'Número de Documento de Identificação',
        taxIdPlaceholder: 'Digite seu número de documento',
        cpf: 'CPF',
        cpfPlaceholder: 'Digite seu CPF',
        cnpj: 'CNPJ',
        cnpjPlaceholder: 'Digite seu CNPJ',
        taxIdType: 'Tipo de Identificação',
        cardNumber: 'Número do Cartão',
        validThru: 'Validade',
        cvv: 'CVV',
        paymentAmount: 'Valor do pagamento',
        monthYear: 'MM/AA',
        payNow: 'Pague agora',
        barcode: 'Código de barras',
        copy: 'Copiar',
        copyPix: 'Copiar Código PIX',
        copied: 'Copiado',
        dueDate: 'Vencimento',
        dueToday: 'Com vencimento hoje',
        additionalData: 'Dados adicionais',
        boletoWasSentTo: 'Boleto foi enviado para',
        boletoSerialNumber: 'Linha digitável',
        pixCode: 'Código PIX',
        cipCode: 'Código de pagamento (CIP)',
        paymentCode: 'Código de pagamento',
        birthDate: 'Data de nascimento',
        dayMonthYear: 'DD/MM/AAAA',
        tryAgain: 'Tentar novamente',
        paymentCardIsProcessing: 'Obrigado, estamos validando o cartão e processando o seu pagamento, por favor aguarde alguns instantes.',
        paymentSuccess: 'Seu pagamento foi processado com sucesso!',
        paymentFailed: 'Infelizmente não foi possível processar o seu pagamento.',
        paymentFailedRedirect: 'Infelizmente não foi possível processar o seu pagamento. Você será redirecionado(a) à loja.',
        subscriptionError: 'Erro ao processar a <br>assinatura',
        bankSlipError: 'Erro ao gerar o <br>Boleto',
        cardError: 'Erro ao validar o <br>Cartão',
        paymentError: 'Erro ao processar o <br>pagamento',
        systemError: 'Erro Sistêmico',
        checkoutLoadFailed: 'Ocorreu um erro ao carregar o checkout',
        invalidData: 'Dados inválidos. Por favor, verifique.',
        paymentRedirectForCheck: 'Obrigado, o processamento do pagamento será feito pela loja onde fez a sua compra. Você será redirecionado para que possa acompanhar o seu pedido.',
        paymentInstructions: 'Instruções de pagamento',
        paymentLocations: 'Locais de pagamento',
        paycashInstructionDetails: 'Para completar seu pagamento, basta apresentar o código de barras em qualquer local de pagamento autorizado. Também enviamos uma cópia por e-mail para sua conveniência. Clique aqui para mais detalhes.',
        email: 'E-mail',
        emailPlaceholder: 'Digite seu e-mail',
        phone: 'Celular',
        individualData: 'Dados Pessoais',
        cardInfo: 'Informações do Cartão',
        bankTransferInstructions: 'Será aberta uma nova janela para a página do seu banco. Se a janela não abrir devido às restrições do seu navegador, clique no LINK abaixo para continuar.',
        bankTransferOpenBankPage: 'Ir para a página do seu banco',
        bank: 'Banco',
        debinAlias: 'Alias DEBIN',
        debinAliasPlaceholder: 'Digite o alias DEBIN da sua conta',
        naturalPerson: 'Pessoa Física',
        company: 'Pessoa Jurídica',
        personType: 'Tipo de Pessoa',
        required: 'Campo Obrigatório',
        invalidEmail: 'Preencha com um e-mail válido',
        invalidTaxId: 'Informe um CPF/CNPJ válido',
        invalidDate: 'Preencha uma data válida',
        invalidExpirationDate: 'Preencha uma data de vencimento válida',
        invalidPhone: 'Preencha com um número de telefone válido',
        invalidCardNumber: 'Preencha um número de cartão válido',
        unacceptedCardNumber: 'Cartão não aceito',
        orderAmount: 'Valor do Pedido',
        totalAmount: 'Valor Total',
        rate: 'Câmbio',
        convertedAmount: 'Valor Convertido',
        payInApp: 'Pagar no App',
        fees: {
          PLATFORM_FEE: 'Taxa de Plataforma',
          TRANSACTION_FEE: 'Taxa de Transação',
          CURRENCY_CONVERSION_FEE: 'Tarifa de câmbio',
          FRAUD_PROTECTION_FEE: 'Taxa de proteção contra fraudes',
          IOF: 'IOF',
          VAT: 'IVA'
        },
        countries: {
          BR: 'Brasil',
          MX: 'México',
        },
        subscription: 'Assinatura',
        completeSubscriptionInfo: 'Você está assinando com o PIX Automático. Por favor, informe seus dados abaixo. Após continuar, verifique o aplicativo do seu banco para autorizar o novo pagamento recorrente.',
        subscriptionDetails: 'Detalhes da assinatura',
        scheme: 'Modalidade',
        periodicity: 'Periodicidade',
        retryPolicy: 'Política de retentativa',
        startDate: 'Data de início',
        endDate: 'Data de término',
        chargeAmount: 'Valor da cobrança',
        minimumAmount: 'Valor mínimo',
        immediateChargeAmount: 'Valor da cobrança imediata',
        fixedChargeInfo: 'Ao confirmar, você autoriza pagamentos recorrentes. Sua primeira cobrança ocorrerá na próxima data de faturamento. Você pode gerenciar ou cancelar esta assinatura a qualquer momento diretamente no aplicativo do seu banco.',
        fixedChargeInfoWithInitialCharge: 'Ao confirmar, você autoriza pagamentos recorrentes. Sua primeira cobrança será processada imediatamente. Você pode gerenciar ou cancelar esta assinatura a qualquer momento diretamente no aplicativo do seu banco.',
        variableChargeInfo: 'Ao confirmar, você autoriza pagamentos recorrentes variáveis. Sua primeira cobrança ocorrerá na próxima data de faturamento. Você pode gerenciar, definir um limite máximo ou cancelar esta assinatura a qualquer momento diretamente no aplicativo do seu banco.',
        variableChargeInfoWithInitialCharge: 'Ao confirmar, você autoriza pagamentos recorrentes variáveis. Sua primeira cobrança será processada imediatamente. Você pode gerenciar, definir um limite máximo ou cancelar esta assinatura a qualquer momento diretamente no aplicativo do seu banco.',
        subscriptionSuccess: 'Assinatura realizada com sucesso!',
        subscriptionSuccessMessage: 'Você tem total controle e pode gerenciar esta assinatura a qualquer momento diretamente no aplicativo do seu banco.',
        cardSubscriptionSuccessMessage: 'Obrigado, o processamento do pagamento será feito pela loja onde você realizou a compra. Você será redirecionado para que possa rastrear seu pedido.',
        subscriptionFailed: 'Falha na assinatura!',
        subscriptionNotice: 'Por favor, reserve um momento para verificar novamente os detalhes do seu plano antes de prosseguirmos com a confirmação do pagamento.',
        nextSteps: 'Próximos passos',
        scanTheQRCode: {
          title: 'Escaneie o QR Code',
          openYourBank: 'Abra o aplicativo do seu banco e selecione a opção PIX.',
          useYourPhone: 'Use a câmera do seu celular para escanear o QR Code exibido na página de checkout ou utilize o "Código PIX" abaixo.'
        },
        authorizeInYourApp: {
          title: 'Autorize no seu aplicativo',
          yourAppWillShow: 'Seu aplicativo exibirá uma solicitação para autorizar o pagamento e a assinatura.',
          forAllFuture: 'Para todos os pagamentos futuros, você pode definir um limite máximo no aplicativo do seu banco.',
          pleaseConfirm: 'Por favor, confirme se o recebedor é: EPLP Tecnologia em Pagamentos CNPJ: 12.012.0192/0001-00'
        },
        subscriptionScheme: {
          PIX_AUTOMATICO: 'PIX Automático',
          CARD: 'Cartão'
        },
        subscriptionPeriodicity: {
          WEEKLY: 'Semanal',
          MONTHLY: 'Mensal',
          QUARTERLY: 'Trimestral',
          HALF_YEARLY: 'Semestral',
          YEARLY: 'Anual'
        },
        subscriptionPeriod: {
          WEEKLY: 'Semana',
          MONTHLY: 'Mês',
          QUARTERLY: 'Trimestre',
          HALF_YEARLY: 'Semestre',
          YEARLY: 'Ano',
        },
        subscriptionAmountType: {
          FIXED: 'Fixo',
          VARIABLE: 'Variável'
        },
        recurringChargeLabel: 'Depois · Todo(a) {period}',
        firstCharge: 'Primeira cobrança: faturada agora, uma única vez',
        nextCharge: 'Cobrança recorrente, com início em',
        paymentSummary: 'Resumo do pagamento',
        subtotal: 'Subtotal',
        customerFee: 'Taxa do cliente',
        nextStep: 'Próximo passo',
        changePaymentMethod: 'Mudar forma de pagamento',
        paymentMethods: 'Formas de pagamento',
        selectPaymentMethod: 'Selecione o método de pagamento perfeito para você',
        termsAndConditions: {
          message: 'Ao prosseguir com esta compra, você concorda com nossos {terms}',
          link: 'Termos e Condições',
        },
        generateQrCode: 'Gerar QR Code',
        qrInteroperable: {
          generateQr: 'Gerar QR Code',
          scanTitle: 'Escaneie o QR Code para pagar',
          qrAlt: 'QR Code de pagamento',
          openApp: 'Abra o Yape, o Plin ou o app do seu banco.',
          scanCode: 'Escaneie o QR Code.',
          confirmPayment: 'Confirme o pagamento no app.',
        },
        breb: {
          scanTitle: 'Escaneie o QR Code para pagar',
          qrAlt: 'QR Code de pagamento',
          openApp: 'Abra o app do seu banco ou carteira digital.',
          chooseBrebQr: 'Escolha pagar com QR Code Bre-B.',
          scanCode: 'Escaneie o QR Code.',
          confirmPayment: 'Confirme o pagamento no app.',
        },
        checkoutLoadErrorTitle: 'Não foi possível carregar seu pagamento',
        checkoutLoadError: 'Recarregue a página para continuar.',
      },
    },
    en: {
      currency: {
        style: 'currency',
        currency: 'BRL',
      },
      message: {
        footer1: 'This data will be used only for the secure processing of payment transactions. Other details like vendor, website or items purchased are not shared and remain private.',
        footer2: 'Your address is used only for the secure processing of payment transactions and will not be used for contact or shared with anyone else.',
        nameFieldInfo: 'Please insert your first name as it is written in your ID.',
        surnameFieldInfo: 'Please insert your last name as it is written in your ID.',
        taxIdInfo: 'Please insert a valid tax id or the transaction might be declined. Your tax id is used only for processing payment transactions and is not linked to the content of your purchase.',
        cardHolderInfo: 'Please type your name matching how it is written on your card.',
        surname: 'Surname',
        namePlaceholder: 'Input your First Name',
        surnamePlaceholder: 'Input your surname',
        confirm: 'Send',
        zipCode: 'Zip Code',
        address: 'Address',
        addressNumber: 'Address Number',
        city: 'City',
        additionalInfo: 'Additional Info',
        state: 'State',
        country: 'Country',
        cardHolderName: 'Card Holder Name',
        taxId: 'Tax ID',
        taxIdPlaceholder: 'Input your Tax ID',
        cpf: 'CPF',
        cpfPlaceholder: 'Input your CPF',
        cnpj: 'CNPJ',
        cnpjPlaceholder: 'Input your CNPJ',
        taxIdType: 'ID Type',
        cardNumber: 'Card Number',
        validThru: 'Valid Thru',
        cvv: 'CVV',
        paymentAmount: 'Payment amount',
        monthYear: 'MM/YY',
        name: 'Name',
        payNow: 'Pay now',
        barcode: 'Barcode',
        copy: 'Copy',
        copyPix: 'Copy PIX Code',
        copied: 'Copied',
        dueDate: 'Due date',
        dueToday: 'Due today',
        additionalData: 'Additional data',
        boletoWasSentTo: 'Boleto was sent to',
        boletoSerialNumber: 'Serial number',
        pixCode: 'PIX code',
        cipCode: 'Payment code (CIP)',
        paymentCode: 'Payment code',
        birthDate: 'Birth date',
        dayMonthYear: 'DD/MM/YYYY',
        tryAgain: 'Try again',
        paymentCardIsProcessing: 'Thank you, please wait a few seconds while we validate your card and process your payment.',
        paymentSuccess: 'Your payment was successfully processed!',
        paymentFailed: 'Sorry, we were unable to process your payment.',
        paymentFailedRedirect: 'Sorry, we were unable to process your payment. We will redirect you to the store.',
        subscriptionError: 'Error processing the <br>subscription',
        bankSlipError: 'Error generating the <br>Boleto',
        cardError: 'Error validating the <br>card',
        paymentError: 'Error processing the <br>payment',
        systemError: 'System error',
        checkoutLoadFailed: 'An error occurred while loading the checkout',
        invalidData: 'Invalid data. Please check it.',
        paymentRedirectForCheck: 'Thank you, the store will process your payment now. You will be redirected to their website to check your order\'s status.',
        paymentInstructions: 'Payment instructions',
        paymentLocations: 'Payment locations',
        paycashInstructionDetails: 'Simply present the barcode at any authorized payment location to complete your payment. We\'ve also emailed a copy for your convenience. Click here for more details.',
        email: 'E-mail',
        emailPlaceholder: 'Input your email',
        phone: 'Phone number',
        individualData: 'Personal data',
        cardInfo: 'Card Info',
        bankTransferInstructions: 'A new window will open for your bank\'s page. If the window does not open due to your browser\'s restrictions, click on the LINK below to continue.',
        bankTransferOpenBankPage: 'Go to your bank\'s page',
        bank: 'Bank',
        debinAlias: 'DEBIN alias',
        debinAliasPlaceholder: 'Enter your account\'s DEBIN alias',
        naturalPerson: 'Natural Person',
        company: 'Company',
        personType: 'Person Type',
        required: 'Required field',
        invalidEmail: 'Enter a valid email',
        invalidTaxId: 'Enter a valid Tax Id',
        invalidDate: 'Enter a valid date',
        invalidExpirationDate: 'Enter a valid expiration date',
        invalidPhone: 'Enter a valid phone number',
        invalidCardNumber: 'Enter a valid card number',
        unacceptedCardNumber: 'Card not accepted',
        orderAmount: 'Order Amount',
        totalAmount: 'Total Amount',
        rate: 'FX Rate',
        convertedAmount: 'Converted Amount',
        payInApp: 'Pay in App',
        fees: {
          PLATFORM_FEE: 'Platform Fee',
          TRANSACTION_FEE: 'Transaction Fee',
          CURRENCY_CONVERSION_FEE: 'Currency Conversion Fee',
          FRAUD_PROTECTION_FEE: 'Fraud Protection Fee',
          IOF: 'Tax - IOF',
          VAT: 'Tax - IVA'
        },
        countries: {
          BR: 'Brazil',
          MX: 'Mexico',
        },
        subscription: 'Subscription',
        completeSubscriptionInfo: 'You are subscribing with PIX Automatico. Please enter your details below. After you continue, check your banking app to authorize the new recurring payment.',
        subscriptionDetails: 'Subscription Details',
        scheme: 'Scheme',
        periodicity: 'Periodicity',
        retryPolicy: 'Retry policy',
        startDate: 'Start date',
        endDate: 'End date',
        chargeAmount: 'Charge Amount',
        minimumAmount: 'Minimum Amount',
        immediateChargeAmount: 'Immediate Charge Amount',
        fixedChargeInfo: 'By confirming, you authorize recurring payments. Your first charge will occur on your next billing date. You can manage or cancel this subscription at any time directly through your bank\'s app.',
        fixedChargeInfoWithInitialCharge: 'By confirming, you authorize recurring payments. Your first charge will be processed immediately. You can manage or cancel this subscription at any time directly through your bank\'s app.',
        variableChargeInfo: 'By confirming, you authorize variable recurring payments. Your first charge will occur on your next billing date. You can manage, set a maximum limit, or cancel this subscription at any time directly through your bank\'s app.',
        variableChargeInfoWithInitialCharge: 'By confirming, you authorize variable recurring payments. Your first charge will be processed immediately. You can manage, set a maximum limit, or cancel this subscription at any time directly through your bank\'s app.',
        subscriptionSuccess: 'Subscription Successful!',
        subscriptionSuccessMessage: ' You have full control and can manage this subscription at any time directly within your bank\'s app.',
        cardSubscriptionSuccessMessage: 'Thank you, the payment processing will be handled by the store where you made your purchase. You will be redirected so you can track your order.',
        subscriptionFailed: 'Subscription Failed!',
        subscriptionNotice: 'Please take a moment to double-check your plan details before we move on to secure payment.',
        nextSteps: 'Next steps',
        scanTheQRCode: {
          title: 'Scan the QR Code',
          openYourBank: 'Open your bank\'s app and select the PIX option.',
          useYourPhone: 'Use your phone\'s camera to scan the QR Code provided on the checkout page, or use the "PIX Code" below.',
        },
        authorizeInYourApp: {
          title: 'Authorize in Your App',
          yourAppWillShow: 'Your app will show a request to authorize the payment and subscription.',
          forAllFuture: 'For all future payments, you can set a maximum limit in your bank\'s app',
          pleaseConfirm: 'Please confirm the recipient is: EPLP Tecnologia em Pagamentos CNPJ: 12.012.0192/0001-00',
        },
        subscriptionScheme: {
          PIX_AUTOMATICO: 'PIX Automático',
          CARD: 'Card'
        },
        subscriptionPeriodicity: {
          WEEKLY: 'Weekly',
          MONTHLY: 'Monthly',
          QUARTERLY: 'Quarterly',
          HALF_YEARLY: 'Half yearly',
          YEARLY: 'Yearly',
        },
        subscriptionPeriod: {
          WEEKLY: 'Week',
          MONTHLY: 'Month',
          QUARTERLY: 'Quarter',
          HALF_YEARLY: 'Half year',
          YEARLY: 'Year',
        },
        subscriptionAmountType: {
          FIXED: 'Fixed',
          VARIABLE: 'Variable',
        },
        recurringChargeLabel: 'Then · Every {period}',
        firstCharge: 'First charge: billed now, once',
        nextCharge: 'Recurring charge, starting',
        paymentSummary: 'Payment Summary',
        subtotal: 'Sub-total',
        customerFee: 'Customer Fee',
        nextStep: 'Next Step',
        changePaymentMethod: 'Change Payment Method',
        paymentMethods: 'Payment Methods',
        selectPaymentMethod: 'Select the perfect payment method for you',
        termsAndConditions: {
          message: 'By proceeding with this checkout, you agree to our {terms}',
          link: 'Terms and Conditions',
        },
        generateQrCode: 'Generate QR Code',
        qrInteroperable: {
          generateQr: 'Generate QR code',
          scanTitle: 'Scan the QR code to pay',
          qrAlt: 'Payment QR code',
          openApp: 'Open Yape, Plin or your bank app.',
          scanCode: 'Scan the QR code.',
          confirmPayment: 'Confirm the payment in the app.',
        },
        breb: {
          scanTitle: 'Scan the QR code to pay',
          qrAlt: 'Payment QR code',
          openApp: 'Open your bank or digital wallet app.',
          chooseBrebQr: 'Choose to pay with a Bre-B QR code.',
          scanCode: 'Scan the QR code.',
          confirmPayment: 'Confirm the payment in the app.',
        },
        checkoutLoadErrorTitle: 'We couldn\'t load your payment',
        checkoutLoadError: 'Reload the page to continue.',
      },
    },
    es: {
      currency: {
        style: 'currency',
        currency: 'BRL',
      },
      message: {
        footer1: 'Esos datos serán utilizados únicamente para el procesamiento seguro de esta transacción. Otros detalles como tienda, website o artículos comprados no son compartidos.',
        footer2: 'Su dirección se usa solo para el procesamiento seguro de transacciones de pago y no se usará para contactar ni se compartirá con nadie más.',
        nameFieldInfo: 'Por favor inserte su nombre como está escrito en su identificación.',
        surnameFieldInfo: 'Por favor inserte su apellido como está escrito en su identificación.',
        taxIdInfo: 'Ingrese una identificación fiscal válida o la transacción podrá ser rechazada. Su identificación fiscal se usa solo para procesar transacciones de pago y no está vinculada al contenido de su compra.',
        cardHolderInfo: 'Escriba su nombre de forma que coincida con la forma en que está escrito en su tarjeta.',
        surname: 'Apellido',
        namePlaceholder: 'Ingrese su nombre',
        surnamePlaceholder: 'Introduce tu apellido',
        confirm: 'Enviar',
        zipCode: 'Código Postal',
        address: 'Calle',
        addressNumber: 'Número',
        city: 'Ciudad',
        additionalInfo: 'Otras informaciones',
        state: 'Estado',
        country: 'País',
        cardHolderName: 'Nombre del titular de la tarjeta',
        taxId: 'Identificación Fiscal',
        taxIdPlaceholder: 'Ingrese su identificación fiscal',
        cpf: 'CPF',
        cpfPlaceholder: 'Ingrese su CPF',
        cnpj: 'CNPJ',
        cnpjPlaceholder: 'Ingrese su CNPJ',
        taxIdType: 'Tipo de Identificación',
        cardNumber: 'Número de la Tarjeta',
        validThru: 'Expiración',
        cvv: 'CVV',
        paymentAmount: 'Monto del pago',
        monthYear: 'MM/AA',
        name: 'Nombre',
        payNow: 'Pagar ahora',
        barcode: 'Código de barras',
        copy: 'Copiar',
        copyPix: 'Copiar código PIX',
        copied: 'Copiado',
        dueDate: 'Fecha límite de pago',
        dueToday: 'Vence hoy',
        additionalData: 'Datos adicionales',
        boletoWasSentTo: 'Boleto fue enviado a',
        boletoSerialNumber: 'Línea digital',
        pixCode: 'Código PIX',
        cipCode: 'Código de pago (CIP)',
        paymentCode: 'Código de pago',
        birthDate: 'Fecha de nacimiento',
        dayMonthYear: 'DD/MM/AAAA',
        tryAgain: 'Intentar nuevamente',
        paymentCardIsProcessing: 'Gracias, estamos validando la tarjeta y procesando su pago, espere unos momentos.',
        paymentSuccess: '¡Su pago ha sido procesado!',
        paymentFailed: 'Lamentablemente, no pudimos procesar su pago.',
        paymentFailedRedirect: 'Lamentablemente, no pudimos procesar su pago. Lo redirigiremos a la tienda.',
        subscriptionError: 'Error al procesar la <br>suscripción',
        bankSlipError: 'Error al generar el <br>Boleto',
        cardError: 'Error al validar la <br>tarjeta',
        paymentError: 'Error al procesar el <br>pago',
        systemError: 'Error del sistema',
        checkoutLoadFailed: 'Ocurrió un error al cargar el checkout',
        invalidData: 'Datos inválidos. Por favor, verifíquelos.',
        paymentRedirectForCheck: 'Gracias, el procesamiento del pago lo realizará la tienda donde realizó su compra. Serás redirigido para que puedas realizar un seguimiento de tu pedido.',
        paymentInstructions: 'Instrucciones de pago',
        paymentLocations: 'Lugares de pago',
        paycashInstructionDetails: 'Para completar su pago, simplemente presente el código de barras en cualquier ubicación de pago autorizada. También le hemos enviado una copia por correo electrónico para su comodidad. Haga clic aquí para obtener más detalles.',
        email: 'E-mail',
        emailPlaceholder: 'Introduce tu correo electrónico',
        phone: 'Número de teléfono',
        individualData: 'Datos individuales',
        cardInfo: 'Información de la tarjeta',
        bankTransferInstructions: 'Se abrirá una nueva ventana para la página de su banco. Si la ventana no se abre debido a las restricciones de su navegador, haga clic en el ENLACE a continuación para continuar.',
        bankTransferOpenBankPage: 'Ir a la página de su banco',
        bank: 'Banco',
        debinAlias: 'Alias DEBIN',
        debinAliasPlaceholder: 'Ingrese el alias DEBIN de su cuenta',
        naturalPerson: 'Persona Natural',
        company: 'Persona Jurídica',
        personType: 'Tipo de Persona',
        required: 'Campo obligatorio',
        invalidEmail: 'Ingresa un correo electrónico válido',
        invalidTaxId: 'Ingresa un documento válido',
        invalidDate: 'Ingresa una fecha válida',
        invalidExpirationDate: 'Ingresa una fecha de vencimiento válida',
        invalidPhone: 'Ingresa un número de teléfono válido',
        invalidCardNumber: 'Ingresa un número de tarjeta válido',
        unacceptedCardNumber: 'Tarjeta no aceptada',
        orderAmount: 'Monto del Pedido',
        totalAmount: 'Monto Total',
        rate: 'Cambio',
        convertedAmount: 'Monto Convertido',
        payInApp: 'Pagar en la App',
        fees: {
          PLATFORM_FEE: 'Tarifa de Plataforma',
          TRANSACTION_FEE: 'Tarifa de Transacción',
          CURRENCY_CONVERSION_FEE: 'Recargo por cambio',
          FRAUD_PROTECTION_FEE: 'Cargo por protección antifraude',
          IOF: 'Impuesto - IOF',
          VAT: 'Impuesto - IVA'
        },
        countries: {
          BR: 'Brasil',
          MX: 'México',
        },
        subscription: 'Suscripción',
        completeSubscriptionInfo: 'Está suscribiéndose con PIX Automático. Por favor, ingrese sus datos a continuación. Después de continuar, revise la aplicación de su banco para autorizar el nuevo pago recurrente.',
        subscriptionDetails: 'Detalles de la suscripción',
        scheme: 'Modalidad',
        periodicity: 'Periodicidad',
        retryPolicy: 'Política de reintentos',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha de finalización',
        chargeAmount: 'Importe del cobro',
        minimumAmount: 'Importe mínimo',
        immediateChargeAmount: 'Importe de cobro inmediato',
        fixedChargeInfo: 'Al confirmar, autoriza pagos pagos recurrentes. Su primer cobro se realizará en su próxima fecha de facturación. Puede administrar o cancelar esta suscripción en cualquier momento directamente desde la aplicación de su banco.',
        fixedChargeInfoWithInitialCharge: 'Al confirmar, autoriza pagos recurrentes. Su primer cobro se procesará de inmediato. Puede administrar o cancelar esta suscripción en cualquier momento directamente desde la aplicación de su banco.',
        variableChargeInfo: 'Al confirmar, autoriza pagos pagos recurrentes variables. Su primer cobro se realizará en su próxima fecha de facturación. Puede administrar, establecer un límite máximo o cancelar esta suscripción en cualquier momento directamente desde la aplicación de su banco.',
        variableChargeInfoWithInitialCharge: 'Al confirmar, autoriza pagos recurrentes variables. Su primer cobro se procesará de inmediato. Puede administrar, establecer un límite máximo o cancelar esta suscripción en cualquier momento directamente desde la aplicación de su banco.',
        subscriptionSuccess: '¡Suscripción realizada con éxito!',
        subscriptionSuccessMessage: 'Tiene control total y puede administrar esta suscripción en cualquier momento directamente desde la aplicación de su banco.',
        cardSubscriptionSuccessMessage: 'Gracias. El procesamiento del pago lo realizará la tienda donde realizó su compra. Será redirigido para que pueda hacer el seguimiento de su pedido.',
        subscriptionFailed: '¡La suscripción ha fallado!',
        subscriptionNotice: 'Por favor, tómese un momento para revisar los detalles de su plan antes de proceder a asegurar el pago.',
        nextSteps: 'Próximos pasos',
        scanTheQRCode: {
          title: 'Escanee el código QR',
          openYourBank: 'Abra la aplicación de su banco y seleccione la opción PIX.',
          useYourPhone: 'Use la cámara de su teléfono para escanear el código QR mostrado en la página de pago o utilice el "Código PIX" a continuación.'
        },
        authorizeInYourApp: {
          title: 'Autorice en su aplicación',
          yourAppWillShow: 'Su aplicación mostrará una solicitud para autorizar el pago y la suscripción.',
          forAllFuture: 'Para todos los pagos futuros, puede establecer un límite máximo en la aplicación de su banco.',
          pleaseConfirm: 'Por favor, confirme que el destinatario es: EPLP Tecnología en Pagos CNPJ: 12.012.0192/0001-00'
        },
        subscriptionScheme: {
          PIX_AUTOMATICO: 'PIX Automático',
          CARD: 'Tarjeta'
        },
        subscriptionPeriodicity: {
          WEEKLY: 'Semanal',
          MONTHLY: 'Mensual',
          QUARTERLY: 'Trimestral',
          HALF_YEARLY: 'Semestral',
          YEARLY: 'Anual'
        },
        subscriptionPeriod: {
          WEEKLY: 'Semana',
          MONTHLY: 'Mes',
          QUARTERLY: 'Trimestre',
          HALF_YEARLY: 'Semestre',
          YEARLY: 'Año',
        },
        subscriptionAmountType: {
          FIXED: 'Fijo',
          VARIABLE: 'Variable'
        },
        recurringChargeLabel: 'Luego · Cada {period}',
        firstCharge: 'Primer cargo: se factura ahora, una sola vez',
        nextCharge: 'Cargo recurrente, a partir de',
        paymentSummary: 'Resumen de pago',
        subtotal: 'Total parcial',
        customerFee: "Tarifa de cliente",
        nextStep: 'Próximo paso',
        changePaymentMethod: 'Cambiar forma de pago',
        paymentMethods: 'Formas de pago',
        selectPaymentMethod: 'Seleccione la forma de pago perfecta para usted',
        termsAndConditions: {
          message: 'Al continuar con este pago, acepta nuestros {terms}',
          link: 'Términos y condiciones',
        },
        generateQrCode: 'Generar QR Code',
        qrInteroperable: {
          generateQr: 'Generar código QR',
          scanTitle: 'Escanee el código QR para pagar',
          qrAlt: 'Código QR de pago',
          openApp: 'Abra Yape, Plin o la app de su banco.',
          scanCode: 'Escanee el código QR.',
          confirmPayment: 'Confirme el pago en la app.',
        },
        breb: {
          scanTitle: 'Escanee el código QR para pagar',
          qrAlt: 'Código QR de pago',
          openApp: 'Abra la app de su banco o billetera digital.',
          chooseBrebQr: 'Elija pagar con código QR Bre-B.',
          scanCode: 'Escanee el código QR.',
          confirmPayment: 'Confirme el pago en la app.',
        },
        checkoutLoadErrorTitle: 'No pudimos cargar su pago',
        checkoutLoadError: 'Recargue la página para continuar.',
      },
    },
  },
})
